import { useCallback, useEffect, useState } from 'react'
import { GPOItem } from '../../Gpo/types'
import { initialState } from '../../../../pages/AddGpo/constants'
import { getGpoDetailsList } from '../../Gpo/api'
import { useSelector } from 'react-redux'
import { getUser } from '../../../../redux/store/user/getters'
import { RowLayout } from 'features/MyCommunity/Vendors/VendorCreation/General/VendorForm/RowLayout'
import { FieldWithLabel } from '../../../../components/FieldWithLabel/FieldWithLabel'
import { LABELS } from '../../../../constants'
import { formatAddress, fullFormatPhoneNumber } from '../../../../helper/common'
import { Typography } from '../../../../components/Typography'
import './styles.scss'
import { LinkHighlighter } from '../../../../components/LinkHighlighter/LinkHighlighter'

export const GpoDetails = () => {
  const user = useSelector(getUser)
  const [details, setDetails] = useState<GPOItem>(initialState)

  const getPredefinedData = useCallback(async () => {
    const res = await getGpoDetailsList(user.gpo)
    setDetails(res?.data)
  }, [user])

  useEffect(() => {
    getPredefinedData()
  }, [user, getPredefinedData])

  return (
    <div className="gpo-details-container">
      <RowLayout title="Business information">
        <div className="mt-12">
          <div className="row">
            <FieldWithLabel title={LABELS.GPO_NAME}>
              {details.name}
            </FieldWithLabel>
          </div>
          <div className="row space-between mt-24 gpo-details-two-items">
            <FieldWithLabel title={LABELS.WEBSITE}>
              {details?.website ? (
                <LinkHighlighter text={details?.website} />
              ) : (
                '-'
              )}
            </FieldWithLabel>
            <FieldWithLabel title={LABELS.PHONE_NUMBER}>
              {details?.phone_number
                ? fullFormatPhoneNumber(details.phone_number)
                : '-'}
            </FieldWithLabel>
          </div>
        </div>
      </RowLayout>
      <div className="mt-24 mb-24 separator" />
      <RowLayout title="Address">
        <div className="mt-12">
          <Typography.Body1>
            {details.address ? formatAddress(details.address) : '-'}
          </Typography.Body1>
        </div>
      </RowLayout>
    </div>
  )
}
